module.exports = __webpack_public_path__ + "static/media/info01.2d8e1717.png";